document.addEventListener("DOMContentLoaded", function () {
    setTimeout(function () {
        let textElement = document.querySelector(".iia-id-104404386174 .iia-title-text");
        let newText = "<strong>Hos leverandører</strong> - ";

        let totalQty = 0;
        const parentClasses = [
            ".iia-id-104404386174",
            ".iia-id-104404451710",
            ".iia-id-104109670782"
        ];

        parentClasses.forEach(parentClass => {
            let parentElement = document.querySelector(parentClass);
            if (parentElement) {
                let qtyElement = parentElement.querySelector(".iia-qty");
                let qtythresholdElement = parentElement.querySelector(".iia-stock-threshold");
                if (qtyElement) {
                    let qty = parseInt(qtyElement.textContent.trim(), 10);
                    if (!isNaN(qty)) {
                        totalQty += qty;
                    }
                }
                if (qtythresholdElement && qtythresholdElement.textContent.trim() === "På lager (20+)") {
                    totalQty += 20;
                }
            }
        });

        
        if (textElement) {
            if (totalQty == 20) {
                textElement.innerHTML = newText + "På lager (20+)";
            } else if (totalQty > 0) {
                textElement.innerHTML = newText + "På lager (" + totalQty + ")";
            } else {
                textElement.innerHTML = newText + "Ikke på lager";
            }
            document.querySelector(".iia-id-104404386174").style.display = "block";
        }
    }, 1000); 
});
